__turbopack_context__.v({
  "productPortfolio__grid": "product-portfolio-module-scss-module__koSiAa__productPortfolio__grid",
});
